exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dropdown-dropdown-3ge6hWf8mwr{display:flex}.dropdown-header-container-5GeU6tVtmwr{padding:0 8px 8px;border-bottom:1px solid var(--ui-divider);margin:0 8px 8px 8px}.dropdown-dark-2vvCoeLRmwr>.dropdown-header-container-5GeU6tVtmwr{border-color:rgba(255,255,255,0.1)}@media screen and (-ms-high-contrast: active){.dropdown-header-container-5GeU6tVtmwr{border-color:windowText}}.dropdown-header-6xm4GRsumwr{padding:4px;padding-left:8px;position:relative;left:-8px}.dropdown-search-6WDcsCKmmwr{background-color:var(--ui-search);border:none}.dropdown-search-6WDcsCKmmwr:focus{border:none;box-shadow:none}.dropdown-scrollable-4ybyHWpWmwr{position:relative;max-height:250px;overflow:auto;padding-bottom:8px}@media (max-height: 250px){.dropdown-scrollable-4ybyHWpWmwr{max-height:calc(100vh - 16px)}.dropdown-header-container-5GeU6tVtmwr+.dropdown-scrollable-4ybyHWpWmwr{max-height:calc(100vh - 16px - 40px)}}.dropdown-list-3rpvMsaJmwr{border-radius:4px;display:inline-block;min-width:140px;width:100%;position:absolute;z-index:3;padding-top:8px}.dropdown-list-3rpvMsaJmwr.dropdown-dark-2vvCoeLRmwr{background-color:#474747}.dropdown-upward-6PYfN0aWmwr{top:auto;bottom:100%}.dropdown-right-Znl0bgh7mwr{left:auto;right:0}.dropdown-portaled-1WIGlHoLmwr{width:0}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"minWidth": "140px",
	"dropdown": "dropdown-dropdown-3ge6hWf8mwr",
	"header-container": "dropdown-header-container-5GeU6tVtmwr",
	"headerContainer": "dropdown-header-container-5GeU6tVtmwr",
	"dark": "dropdown-dark-2vvCoeLRmwr",
	"header": "dropdown-header-6xm4GRsumwr",
	"search": "dropdown-search-6WDcsCKmmwr",
	"scrollable": "dropdown-scrollable-4ybyHWpWmwr",
	"list": "dropdown-list-3rpvMsaJmwr",
	"upward": "dropdown-upward-6PYfN0aWmwr",
	"right": "dropdown-right-Znl0bgh7mwr",
	"portaled": "dropdown-portaled-1WIGlHoLmwr"
};